import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { ConsentService, ComplianzConsent } from '../../services/cookie-consent.service';

@Component({
  selector: 'app-consent-banner',
  templateUrl: './consent-banner.component.html',
  styleUrls: ['./consent-banner.component.css'],
  standalone: true,
  imports: [NgIf, NgFor]
})
export class ConsentBannerComponent implements OnInit {
  @Output() closeBanner = new EventEmitter<void>();
  open = false;
  current: ComplianzConsent = {
    functional: 'allow',
    preferences: null,
    statistics: null,
    marketing: null
  };
  policyIdFromWP = '';
  expandedCategories: { [key: string]: boolean } = {};

  constructor(private consentService: ConsentService) {}

  ngOnInit() {
    console.log('=== ConsentBanner Component Initialized ===');
    console.log('Current domain:', window.location.hostname);
    console.log('Available cookies:', document.cookie);
    
    this.current = this.getCurrentConsent();
    const hasChoice = this.hasAnyChoice();
    console.log('ConsentBanner ngOnInit - hasChoice:', hasChoice);
    console.log('ConsentBanner ngOnInit - current consent:', this.current);
    
    // Lógica normal: mostra banner se não tem consentimento, mostra aba se tem
    this.open = !hasChoice;
    console.log('ConsentBanner ngOnInit - banner open:', this.open);
  }

  setCategory(cat: string, val: 'allow' | 'deny') {
    (this.current as any)[cat] = val;
  }

  toggleCategory(cat: string) {
    const isAllowed = this.isCategoryAllowed(cat);
    this.setCategory(cat, isAllowed ? 'deny' : 'allow');
  }

  toggleExpanded(cat: string) {
    this.expandedCategories[cat] = !this.expandedCategories[cat];
  }

  save() {
    // Usar o serviço de consentimento para salvar
    this.consentService.save({
      preferences: this.current.preferences || 'deny',
      statistics: this.current.statistics || 'deny',
      marketing: this.current.marketing || 'deny',
      policyId: this.policyIdFromWP
    });
    
    this.open = false;
    this.closeBanner.emit();
  }

  private getCurrentConsent(): ComplianzConsent {
    // Usar o serviço de consentimento para ler
    return this.consentService.read();
  }

  private hasAnyChoice(): boolean {
    return this.consentService.hasAnyChoice();
  }

  private getAllowedCategories(): string[] {
    const categories: string[] = [];
    
    // Funcionais estão sempre ativos
    categories.push('functional');
    
    if (this.current.preferences === 'allow') categories.push('preferences');
    if (this.current.statistics === 'allow') categories.push('statistics');  
    if (this.current.marketing === 'allow') categories.push('marketing');
    
    return categories;
  }

  acceptAll(): void {
    this.consentService.save({
      preferences: 'allow',
      statistics: 'allow',
      marketing: 'allow',
      policyId: this.policyIdFromWP
    });
    
    this.open = false;
    this.closeBanner.emit();
  }

  acceptNecessary(): void {
    this.consentService.save({
      preferences: 'deny',
      statistics: 'deny',
      marketing: 'deny',
      policyId: this.policyIdFromWP
    });
    
    this.open = false;
    this.closeBanner.emit();
  }

  close(): void {
    this.open = false;
    this.closeBanner.emit();
  }

  openBanner(): void {
    this.open = true;
  }

  hasConsent(): boolean {
    return this.hasAnyChoice();
  }

  isCategoryAllowed(category: string): boolean {
    return this.current.savedCategories?.includes(category) || false;
  }



  getCategoryTitle(category: string): string {
    const titles: { [key: string]: string } = {
      'preferences': 'Preferências',
      'statistics': 'Estatísticas',
      'marketing': 'Marketing'
    };
    return titles[category] || category;
  }

  getCategoryDescription(category: string): string {
    const descriptions: { [key: string]: string } = {
      'preferences': 'Cookies que armazenam suas preferências e personalizações do site.',
      'statistics': 'Cookies que nos ajudam a entender como os visitantes interagem com o site.',
      'marketing': 'Cookies utilizados para personalizar anúncios e medir o desempenho de campanhas.'
    };
    return descriptions[category] || '';
  }

  getCategoryExpandedText(category: string): string {
    const expandedTexts: { [key: string]: string } = {
      'functional': 'O armazenamento ou acesso técnico é estritamente necessário para o fim legítimo de permitir a utilização de um determinado serviço expressamente solicitado pelo assinante ou utilizador, ou para o fim exclusivo de efetuar a transmissão de uma comunicação numa rede de comunicações eletrónicas.',
      'preferences': 'O armazenamento ou acesso técnico é necessário para o propósito legítimo de armazenamento de preferências não solicitadas pelo assinante ou utilizador.',
      'statistics': 'O armazenamento técnico ou acesso que é usado exclusivamente para fins estatísticos anónimos. Sem uma intimação, conformidade voluntária por parte do seu Fornecedor de Serviços de Internet ou registos adicionais de terceiros, as informações armazenadas ou recuperadas apenas para esse fim geralmente não podem ser usadas para identificá-lo.',
      'marketing': 'O armazenamento ou acesso técnico é necessário para criar perfis de utilizador para enviar publicidade ou para rastrear o utilizador num site ou em vários sites para fins de marketing semelhantes.'
    };
    return expandedTexts[category] || '';
  }
}